import { createContext } from 'react';
import { useFiltersContext } from '../../../../Common/Filters/hooks/useFiltersContext';
import {
    QUERY_KEYS_ESUS,
    useChartsData
} from '../../../Common/Filters/useChartsData';

export const GeneralProductionChartsDataContext = createContext();

const GeneralProductionChartsDataProvider = ({ children }) => {
    const { filters } = useFiltersContext();
    const { data, isLoading, isError } = useChartsData(
        {
            key: QUERY_KEYS_ESUS.REGISTERS_MAPPING,
            url: 'governanceroom/esus/production/generalproduction'
        },
        {
            year: filters.ano.value,
            month: filters.competencia.map((competencia) => competencia.value),
            location: filters.unidade.value,
            city: filters.cidade?.governance_room_geo_city_id,
        }
    );

    const chartData = data
        ? {
              annualEvolutionServices: data?.annualEvolutionServices ?? [],
              monthlyEvolutionServices: data?.monthlyEvolutionServices ?? [],
              servicesByType: data?.servicesByType ?? [],
              servicesByAge: data?.servicesByAge ?? [],
              servicesBySex: data?.servicesBySex ?? []
          }
        : {
              annualEvolutionServices: [],
              monthlyEvolutionServices: [],
              servicesByType: [],
              servicesByAge: [],
              servicesBySex: []
          };

    return (
        <GeneralProductionChartsDataContext.Provider
            value={{
                chartData,
                isLoading,
                isError,
                filters,
                data
            }}
        >
            {children}
        </GeneralProductionChartsDataContext.Provider>
    );
};

export default GeneralProductionChartsDataProvider;
